<h2 mat-dialog-title>
  Send us your feedback
  <button mat-icon-button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (feedbackSubmitted) {
    <div class="feedback-success" @successMessage>
      <span>Feedback submitted successfully!</span>
    </div>
  } @else {
    <textarea class="feedback-textarea" placeholder="Your feedback..." [(ngModel)]="feedbackInput" rows="8"> </textarea>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close [disabled]="feedbackSubmittedLoader">Cancel</button>
  <button
    mat-flat-button
    class="send-feedback-btn"
    [disabled]="!feedbackInput || feedbackInput.trim() === '' || feedbackSubmittedLoader"
    (click)="sendFeedback()">
    @if (feedbackSubmittedLoader) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Send Feedback
    }
  </button>
</mat-dialog-actions>
